import React, { forwardRef } from 'react'
import { InputGroupProps as ChakraInputGroupProps } from '@chakra-ui/core'

import { Box } from '../Box'
import { InputLeftElement, InputRightElement } from '../InputElement'
import { TextInput } from '../TextInput'
import { useTheme } from '../../hooks/useTheme'
import { useInputStyle } from '../../hooks/useInputStyle'

export interface InputGroupProps extends ChakraInputGroupProps {
  children: React.ReactNode
}

export const InputGroup = forwardRef(
  ({ children, size = 'md', ...props }: InputGroupProps, ref) => {
    const { height } = useInputStyle({ size })
    const { sizes } = useTheme()

    let pl = null
    let pr = null

    return (
      <Box display="flex" position="relative" ref={ref} {...props}>
        {React.Children.map(children, child => {
          if (!React.isValidElement(child)) {
            return child
          }

          if (child.type === InputLeftElement) {
            pl = sizes[height]
          }

          if (child.type === InputRightElement) {
            pr = sizes[height]
          }

          if (child.type === TextInput) {
            return React.cloneElement(child, {
              size,
              pl: child.props.pl || pl,
              pr: child.props.pr || pr,
            })
          }

          return React.cloneElement(child, { size })
        })}
      </Box>
    )
  },
)

InputGroup.displayName = 'InputGroup'

export default InputGroup
